import { Component, OnInit } from '@angular/core';
import {
  Flight,
  FlightRule,
  FlightType,
  OperationType,
} from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';

@Component({
    selector: 'app-atc-data',
    templateUrl: './atc-data.component.html',
    styleUrls: ['./atc-data.component.scss'],
    standalone: false
})
export class AtcDataComponent implements OnInit {
  public flight = new Flight();
  public flightTypeOption = FlightType;
  public operationTypeOption = OperationType;
  public flightRuleOption = FlightRule;
  constructor(public flightPlanService: FlightPlanService) { }

  public ngOnInit() {
    this.flight = this.flightPlanService.atcDetails;
  }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('flightdetails');
  }
  public selectOperationType() {

  }
}
